import { useMutation } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { claimNFT } from '../communities.service';
export const useClaimNFTReward = (questId) => {
    const subdomain = getSubdomain();
    return useMutation({
        mutationFn: (params) => claimNFT(subdomain, params.address, questId, params.nftId),
    });
};
